import 'components/404/404.css'
import Seo from 'components/seo/seo'

function PageNotFound404() {
  return (
    <section className="page_404">
      <Seo
        title="Opss, duket qe diqka nuk eshte ne rregull!"
        description="404 Page not found, faqja qe kerkoni me shume gjasa nuk egziston"
      />
      <div className="container">
        <div className="row">
          <div className="col-sm-12 ">
            <div className="col-sm-10 col-sm-offset-1  text-center">
              <div className="four_zero_four_bg">
                <h1 className="text-center ">404</h1>
              </div>
              <div className="contant_box_404">
                <h3 className="h2">
                  Opss, duket qe diqka nuk eshte ne rregull!
                </h3>
                <p>Faqja qe kerkoni me shume gjasa nuk egziston</p>
                <a href="/" className="link_404">
                  Kthehuni prapa
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PageNotFound404
